import { create, type StateCreator } from 'zustand'
import { createJSONStorage, devtools, persist } from 'zustand/middleware'
import { zustandPlugin } from '@/modules/shared/openreplay'
import type { DayTypePaletteId } from '@/modules/drivers/tabs/activities/components/charts/yearly/palettes/dayTypePalettes'

type State = {
  paletteId: DayTypePaletteId
}

type Actions = {
  setPaletteId: (paletteId: DayTypePaletteId) => void
}

const creator: StateCreator<State & Actions> = (set) => ({
  paletteId: 'classic',
  setPaletteId: (paletteId) =>
    (set as (p: Partial<State>, replace?: boolean, action?: string) => void)(
      { paletteId },
      false,
      'setPaletteId',
    ),
})

export const useDayTypePaletteStore = create<State & Actions>()(
  devtools(
    persist(
      zustandPlugin(creator, 'day-type-palette') as StateCreator<
        State & Actions
      >,
      {
        name: 'day-type-palette',
        storage: createJSONStorage(() => localStorage),
        partialize: (s) => ({ paletteId: s.paletteId }),
      },
    ),
    { name: 'EasyTacho', store: 'day-type-palette' },
  ),
)

export const useDayTypePalette = () =>
  useDayTypePaletteStore((s) => s.paletteId)
